// extracted by mini-css-extract-plugin
export default {"scannerWrapper":"Html5QrcodePlugin_scannerWrapper__mQ5EM"};